export default "__VITE_ASSET__CTvYmkBG__"